// extracted by mini-css-extract-plugin
module.exports = {"container":"table_container__ckshy"};